import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import LoadingIndicator from "layout/components/Loading";
import Table from "components/table/Table";
import { AddButton, MediumScreenModel } from "components";
import { columnVisibilityItems } from "./columnVisibilityItems";
import { TableColumns } from "./TableColumns";
import { fetchUsers } from "../../store/action";
import HandleUserCreate from "../manage_user/HandleUserCreate";
import { useUser } from "utils/helpers/UserContext";
import { Authorities } from "props/authoritries";
import { SuperAdminStatusEnum } from '../../../../../props/enum';

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;
const UserTable: React.FC<Props> = ({ onFetchUsers, fetchUsers }) => {
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin ||
     action?.includes(Authorities.CREATE_CMS_USER));
  const status = "Active";
  const [isModalOpen, setModalOpen] = useState(false);
  const closeModal = () => {
    setModalOpen(false);
    onFetchUsers(status); 
  };
  const openModal = () => setModalOpen(true);
  useEffect(() => {
    onFetchUsers(status);
  }, [onFetchUsers, status]);

  const { isLoading, users } = fetchUsers;
  const currentUsers = users;

  if (isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <div className="">
      <Table
        headers={["System Setup", "System Users"]}
        data={currentUsers}
        columnVisibilityItems={columnVisibilityItems}
        tableColumns={TableColumns}
        addButton={
          <>
            {isPermitted && (
              <AddButton
                onClick={openModal}
                label="Add User"
                tooltip="Add new user"
              />
            )}
          </>
        }
      />
      <MediumScreenModel showModal={isModalOpen} setShowModal={setModalOpen}>
        <div className="text-center">
          <HandleUserCreate closeModal={closeModal} />
        </div>
      </MediumScreenModel>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    fetchUsers: state.users.fetchUsersState,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  onFetchUsers: (status: string) => dispatch(fetchUsers(status)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserTable);